import { AEMMedallionBannerContent } from '../../models';

export const AemMedallionBannerContentMocks: AEMMedallionBannerContent = {
  medallionBanner: {
    accountNumberLabel: 'SKYMILES #',
    analyticsEvent: { name: 'edl-ready', value: 'skymiles overview page' },
    ariaLabel: {
      level: 'graphic level',
      millionMiler: 'logo million miler',
      skyPriorityLabel: 'clickable Sky Priority button opens in new tab'
    },
    availableMilesLabel: 'MILES AVAILABLE',
    label360: 'DELTA 360&deg; ™ and ',
    medallionDetails: {
      medallion: [
        {
          medallionId: 'FF',
          medallionLabel: 'SkyMiles® Member',
          medallionBenefitMessage: 'VIEW YOUR BENEFITS',
          medallionBenefitUrl:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          medallionBenefit360Message: 'discover exclusive benefits',
          medallionBenefit360Url:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          openMedallionBenefitUrlNewTab: true
        },
        {
          medallionId: 'FO',
          medallionLabel: 'Silver Medallion',
          medallionBenefitMessage: 'VIEW YOUR BENEFITS',
          medallionBenefitUrl:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          medallionBenefit360Message: 'discover exclusive benefits',
          medallionBenefit360Url:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          openMedallionBenefitUrlNewTab: true
        },
        {
          medallionId: 'GM',
          medallionLabel: 'Gold Medallion',
          medallionBenefitMessage: 'VIEW YOUR BENEFITS',
          medallionBenefitUrl:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          medallionBenefit360Message: 'discover exclusive benefits',
          medallionBenefit360Url:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          openMedallionBenefitUrlNewTab: true
        },
        {
          medallionId: 'PM',
          medallionLabel: 'Platinum Medallion',
          medallionBenefitMessage: 'VIEW YOUR BENEFITS',
          medallionBenefitUrl:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          medallionBenefit360Message: 'discover exclusive benefits',
          medallionBenefit360Url:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          openMedallionBenefitUrlNewTab: true
        },
        {
          medallionId: 'DM',
          medallionLabel: 'Diamond Medallion',
          medallionBenefitMessage: 'VIEW YOUR BENEFITS',
          medallionBenefitUrl:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          medallionBenefit360Message: 'discover exclusive benefits',
          medallionBenefit360Url:
            '/us/en/skymiles/medallion-program/medallion-benefits',
          openMedallionBenefitUrlNewTab: true
        }
      ]
    },
    millionMilerLabel: 'MILLION MILER™',
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority'
    },
    salutationCards: {
      salutation: [
        { salutationId: 'goodMorning', salutationLabel: 'Good Morning' },
        { salutationId: 'goodAfternoon', salutationLabel: 'Good Afternoon' },
        { salutationId: 'goodEvening', salutationLabel: 'Good Evening' }
      ]
    },
    showDurationLabel: 'SKYMILES MEMBER SINCE',
    statusLabel: 'CURRENT STATUS:',
    trademark: '®'
  }
};
